var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.99805C17 10.498 16.58 11.918 15.84 13.118C15.42 13.838 14.88 14.478 14.26 14.998C12.86 16.258 11.02 16.998 9 16.998C6.08 16.998 3.54 15.438 2.16 13.118C1.42 11.918 1 10.498 1 8.99805C1 6.47805 2.16 4.21806 4 2.75806C5.38 1.65806 7.12 0.998047 9 0.998047C13.42 0.998047 17 4.57805 17 8.99805Z",
    stroke: "#444444",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1394 11.0776L6.89941 6.85767",
    stroke: "#444444",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8416 6.71509L6.60156 10.9351",
    stroke: "#444444",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a5c80a36ec3486ca16747cf824983fb2.svg";
export { ForwardRef as ReactComponent };